import { IYoutubeChannel } from "../../../../../api/youtube";
import { openNewWindow } from "../../../../../utils/common";
import {
  HomeYoutubeChannelItemInfo,
  HomeYoutubeChannelItemTitleRow,
  HomeYoutubeChannelItemThumbnailImage,
  HomeYoutubeChannelItemWrapper,
  HomeYoutubeChannelListWrapper,
  HomeYoutubeChannelWrapper,
  HomeYoutubeHeader,
} from "./styles";
import { Swiper, SwiperSlide } from "swiper/react";

interface HomeYoutubeChannelProps {
  channels: IYoutubeChannel[];
}

const HomeYoutubeChannel = ({ channels }: HomeYoutubeChannelProps) => {
  const slidesPerView = 4.5;
  return (
    <HomeYoutubeChannelWrapper>
      <HomeYoutubeHeader>
        인기 <span>유튜버</span>
      </HomeYoutubeHeader>
      <HomeYoutubeChannelListWrapper>
        <Swiper
          className="channel-list"
          slidesPerView={slidesPerView ? slidesPerView : 5.5}
        >
          {channels.map((item, index) => (
            <SwiperSlide>
              <HomeYoutubeChannelItemWrapper
                key={index}
                onClick={() => openNewWindow(item.url)}
              >
                <HomeYoutubeChannelItemThumbnailImage
                  width={slidesPerView ? 62 : 50}
                >
                  <img src={item.profileUrl} alt={item.name} />
                </HomeYoutubeChannelItemThumbnailImage>
                <HomeYoutubeChannelItemInfo>
                  <HomeYoutubeChannelItemTitleRow>
                    <div className="title">{item.name}</div>
                  </HomeYoutubeChannelItemTitleRow>
                </HomeYoutubeChannelItemInfo>
              </HomeYoutubeChannelItemWrapper>
            </SwiperSlide>
          ))}
        </Swiper>
      </HomeYoutubeChannelListWrapper>
    </HomeYoutubeChannelWrapper>
  );
};

export default HomeYoutubeChannel;
